import $ from "jquery";
import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";

import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import init from '../../AccessControl/Check';
import moment from "moment";
import UserBasicInfoContext from "../../../../components/Context/UserBasicInfoContext";
import { SUPER_ADMIN_CODE, USER_CODE } from "../../ConstRole/ConstRole";

const VoucherCategory = () => {
    const pageName = "Voucher Category View";
    const isAccess = init(pageName);



    const userProfile = useContext(UserBasicInfoContext);

    const [reqParam, setReqParam] = useState({
        page: 1,
    });

    const showDropDown = event => {
        $(".dropdownDotsHorizontal").hide();
        event.currentTarget.nextSibling.style.display = "block";
    }

    document.addEventListener('scroll', function () {
        $(".dropdownDotsHorizontal").hide();
    }, true);

    $('body').on("click", function (e) {
        if (e.target?.parentElement?.className === "" || e.target?.parentElement?.className === null || e.target?.parentElement?.className === undefined) {
            return;
        }

        if (e.target.parentElement.className.toString().includes("dropdownMenuIconHorizontalButton mt-2") === false) {
            $(".dropdownDotsHorizontal").hide();
        }
    });

    const [categoryList, setCategoryList] = useState([]);
    const [deleteModal, setDeleteModal] = useState({
        isShow: false,
        id: ""
    });
    const [isRefresh, setIsRefresh] = useState(0);

    const [apiData, setApiData] = useState({});



    // Get Voucher Categories with Pagination
    useEffect(() => {
        PostLoginGetApi("voucher/category-pagination", reqParam, 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setCategoryList(responseData["data"]["data"]);
                    setDeleteModal(false);
                    return;
                }

                toast.error(responseData["messages"].toString());
            }

        }).catch((err) => {
            console.log(err);
        });
    }, [isRefresh, reqParam]);


    //* Delete Voucher Category
    const deleteVoucherCategory = (id) => {
        try {
            PostLoginPostApi("voucher/category/remove/" + id, "", 3, 0, 3).then((responseJSON) => {
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    var responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200) {
                        setDeleteModal(false);
                        toast.success(responseData["messages"].toString() ?? "Voucher Category status update successfully.");
                        setIsRefresh((prevCounter) => {
                            return prevCounter + 1;
                        });

                        return;
                    }

                    toast.error(responseData["messages"].toString() ?? responseData["message"].toString() );
                    return;

                }
            }).catch((error) => {
                toast.error("A problem occur. Please try again.");
                console.log(error);
            });
        }
        catch (exception) {
            toast.error("A problem occur.");
            console.log(exception);
        }
    }

    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="custom-container w-full font-montserrat flex -mt-4">

            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] py-3">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5">Here’s your voucher categories at a glance</h6>
                    </div>

                    <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">
                        <Link to={"create-voucher-category"} className="custom-btn text-center">Create voucher category</Link>
                    </div>
                </div>





                {/* DATA TABLE  */}
                <div className="flex flex-col w-full pt-4">
                    <div className='-m-1.5 pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className='border rounded-lg shadow'>
                                <table className='min-w-full divide-y divide-gray-200 custom-table-hover '>
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="px-4 py-3 text-center w-16">#</th>
                                            <th scope="col" className="px-6 py-3 w-[80px] text-center">Icon</th>
                                            <th scope="col" className="px-6 py-3">Name</th>
                                            <th scope="col" className="px-2 py-3 text-center w-[150px]">Position</th>
                                            <th scope="col" className="px-2 py-3 text-center w-[150px]">Is Active?</th>
                                            <th scope="col" className="px-4 py-3 w-56">Created Date</th>
                                            <th scope="col" className="px-4 py-3 w-56">Updated Date</th>
                                            <th></th>
                                        </tr>
                                    </thead>

                                    <tbody className='divide-y divide-gray-200'>
                                        {(categoryList.length === 0) &&
                                            <tr key="0">
                                                <td colSpan={8} className='px-6 py-1 '>
                                                    <p className='py-4'>No voucher category available</p>
                                                </td>
                                            </tr>
                                        }

                                        {categoryList.map((data, index) => (
                                            <tr key={index}>
                                                <td className='px-4 py-2 border-r-2 text-center font-semibold'>
                                                    {(apiData?.from ?? 0 * 1) + index}
                                                </td>
                                                <td className='px-6 py-2 text-center border-r-2 '>
                                                    {(data.icon?.length > 0) && 
                                                        <img src={data.icon} alt="Category Icon" className="max-w-10 max-h-10  inline"/>
                                                    }
                                                </td>
                                                <td className='px-6 py-1 border-r-2 '>{data.name}</td>
                                                <td className='px-2 py-1 border-r-2 text-center'>{data.position ?? ""}</td>
                                                <td className='px-2 py-1 border-r-2 text-center'>
                                                    {(data.status) ? <span className="text-green-600">YES</span> : <span className="text-red-600">NO</span>}
                                                </td>
                                                <td className='px-4 py-4 border-r-2'>
                                                    {moment(data.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-4 py-4 border-r-2'>
                                                    {moment(data.updated_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-6 py-1 text-center w-[120px]'>
                                                    <button onClick={showDropDown} data-dropdown-toggle="dropdownDotsHorizontal" className="dropdownMenuIconHorizontalButton mt-2">
                                                        <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"></path></svg>
                                                    </button>

                                                    <div className="dropdownDotsHorizontal hidden relative z-50">
                                                        <div className='absolute -ml-20 -mt-2 border border-[1px solid rgb(245, 245, 245)] bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600'>
                                                            <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownMenuIconHorizontalButton">
                                                                <li className='border-b-[1px] border-b-slate-100'>
                                                                    {(userProfile?.user_type_id === SUPER_ADMIN_CODE || userProfile?.user_type_id === USER_CODE) && 
                                                                        <Link to={"/dashboard/voucher/sort-brand"} state={{ data: data }} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                            Sort
                                                                        </Link>
                                                                    }
                                                                </li>
                                                                <li className='border-b-[1px] border-b-slate-100'>
                                                                    <Link to={"edit-voucher-category"} state={{ data: data }} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                        Edit
                                                                    </Link>
                                                                </li>
                                                                <li className="border-b-[1px] border-b-slate-100">
                                                                    <span onClick={() => setDeleteModal({ isShow: true, id: data?.id })} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                        {(data.status) ? "Inactive" : "Active"} 
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>

                            </div>


                            {(apiData?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.from * 1} - ${apiData?.to * 1} out of ${apiData?.total * 1}`}
                                    </p>


                                    {(apiData?.next_page_url !== null && apiData?.next_page_url !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.prev_page_url !== null && apiData?.prev_page_url !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5 mr-2">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Popup */}
            {((deleteModal?.isShow === true) && deleteModal.id !== "") ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            {/*content*/}
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <button type="button" onClick={() => setDeleteModal(false)} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-toggle="popup-modal">
                                    <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                                <div className="p-6 text-center">
                                    <svg aria-hidden="true" className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Are you sure you want to update status ?</h3>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => deleteVoucherCategory(deleteModal.id)} className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                        Yes, I'm sure
                                    </button>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => setDeleteModal(false)} className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">No, cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}

        </div>
    );
};

export default VoucherCategory;